import React from 'react';
import { AttemptStatus } from '../types';
import { useTranslation } from '../../../i18n';

interface AttemptStatusBadgeProps {
  status: AttemptStatus | string;
  className?: string;
}

export const AttemptStatusBadge: React.FC<AttemptStatusBadgeProps> = ({ status, className = '' }) => {
  const { t } = useTranslation();
  const normalized = (status || '').toUpperCase();

  let label = normalized;
  let bgClass = 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-300 dark:border-slate-700';

  switch (normalized) {
    case 'IN_PROGRESS':
    case 'INITIALIZING':
      label = t('status.in_progress', undefined, 'In Progress');
      bgClass = 'bg-blue-50 text-blue-700 dark:bg-blue-950/60 dark:text-blue-300 border-blue-200 dark:border-blue-800';
      break;
    case 'PAUSED':
      label = t('status.paused', undefined, 'Paused');
      bgClass = 'bg-amber-50 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300 border-amber-200 dark:border-amber-800';
      break;
    case 'COMPLETED':
    case 'SUBMITTED':
      label = t('status.completed', undefined, 'Completed');
      bgClass = 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800';
      break;
    case 'EVALUATED':
    case 'SCORED':
      label = t('status.evaluated', undefined, 'Evaluated');
      bgClass = 'bg-purple-50 text-purple-700 dark:bg-purple-950/60 dark:text-purple-300 border-purple-200 dark:border-purple-800';
      break;
    case 'EXPIRED':
      label = t('status.expired', undefined, 'Expired');
      bgClass = 'bg-rose-50 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300 border-rose-200 dark:border-rose-800';
      break;
    case 'ABANDONED':
      label = t('status.abandoned', undefined, 'Abandoned');
      bgClass = 'bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400 border-zinc-300 dark:border-zinc-700';
      break;
    default:
      label = normalized || t('status.unknown', undefined, 'Unknown');
  }

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${bgClass} ${className}`}
    >
      {label}
    </span>
  );
};
